import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { useParams } from 'react-router-dom'
import { post } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { Icon } from '@iconify/react'
import './CustomerModals.scss'

function AdjustDebt({ fetchTransaction, fetchUser, setShowDeduct }: any) {
  const { id } = useParams()
  const { notify } = useGlobalContext()
  const [cancelLoading, setCancelLoading] = useState(false)
  const [amount, setAmount] = useState(0)

  async function updateDebt() {
    const data = {
      amount: amount,
    }
    if (amount < 1) {
      notify('warn', 'Input Amount')
      return
    }
    setCancelLoading(true)
    post(`admin/deduct-debt/${id}`, data, null)
      .then((result: any) => {
        if (result.status === 200) {
          notify('success', 'Debt Updated')
          setShowDeduct(false)
          fetchUser()
          fetchTransaction(1, 'all', 10)
        } else {
          notify('error', result.message)
        }
        setCancelLoading(false)
      })
      .catch(() => {
        setCancelLoading(false)
      })
  }

  return (
    <Modal position='center'>
      <div className='customer-modal'>
        <div className='modal-header'>
          <div className='modal-icon icon-orange'>
            <Icon icon='mdi:cash-minus' />
          </div>
          <h2>Adjust User's Debt</h2>
          <p>Enter an amount to reduce the outstanding debt owed by this user.</p>
        </div>

        <div className='form-group'>
          <label>Amount (NGN)</label>
          <input
            type='number'
            min={1}
            placeholder='e.g. 5000'
            onChange={(e) => setAmount(parseFloat(e.target.value))}
          />
        </div>

        {cancelLoading ? (
          <FormLoader position='center' />
        ) : (
          <div className='modal-actions'>
            <button className='btn-cancel' onClick={() => setShowDeduct(false)}>
              Cancel
            </button>
            <button className='btn-proceed' onClick={updateDebt}>
              Log Payment
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default AdjustDebt
